<template>
  <div class="s-coming-soon__wrapper">
    <div class="s-coming-soon__content">
      <div class="s-coming-soon__img">
        <picture>
          <source :srcset="thumb" media="(max-width: 768px)" />
          <img :src="img" :alt="title" />
        </picture>
        <ScreenTypes
          :sphera="sphera"
          :dolby="dolby"
          :three-dimensions="threeDimensions"
          :imax="imax"
          :imax3d="imax3D" />
      </div>

      <div class="s-coming-soon__container">
        <div class="s-coming-soon__el-holder">
          <div
            v-if="dictionary.ticketsFrom"
            class="e-label e-label--bg e-label--ticket">
            <span>{{ dictionary.ticketsFrom }}</span>
            {{ showDueDate(due) }}
          </div>
          <ScreenTypes
            :sphera="sphera"
            :dolby="dolby"
            :three-dimensions="threeDimensions"
            :imax="imax"
            :imax3d="imax3D" />
        </div>

        <div class="s-coming-soon__content-container">
          <div v-if="dictionary.ticketsFrom" class="e-label e-label--ticket">
            <span>{{ dictionary.ticketsFrom }}</span>
            {{ showDueDate(due) }}
          </div>
          <div class="s-coming-soon__content-container__title">
            {{ title }}
          </div>
          <div class="s-coming-soon__content-container__subtitle">
            {{ subtitle }}
          </div>
          <div
            class="s-coming-soon__content-container__description multiline-ellipse"
            v-html="desc"></div>

          <div class="b-hor-align b-hor-align--gap-16">
            <div v-if="pg" class="e-k">{{ pg }}</div>
            <!-- <div v-if="genres.length && genres[0]" class="movie-attr--movie">
              <span>
                <em v-for="genre in genres" :key="genre">
                  {{ genre }}
                </em>
              </span>
            </div> -->
            <div v-if="duration" class="movie-attr--time">
              <span>{{ duration }}</span>
            </div>
          </div>
        </div>

        <div class="s-coming-soon__btn-area clearfix">
          <button
            type="button"
            class="s-coming-soon__cta s-coming-soon__cta--desktop"
            @click="clickToNotify">
            <span>{{ dictionary.notify }}</span>
          </button>
          <button
            type="button"
            class="s-coming-soon__cta s-coming-soon__cta--device"
            @click="clickToNotifyDevice">
            <span>{{ dictionary.notify }}</span>
          </button>
          <a :href="url" class="s-coming-soon__cta-more">
            {{ dictionary.more }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLocale } from '../../lib/lib'
import { getFormattedDateWithSeparators } from '../../lib/date'
import ScreenTypes from '../components/Shared/ScreenTypes.vue'

export default {
  components: { ScreenTypes },
  props: {
    recordId: { default: '', type: String, required: true },
    title: { default: '', type: String, required: true },
    subtitle: { default: '', type: String },
    thumb: { default: '', type: String, required: true },
    img: { default: '', type: String, required: true },
    desc: { default: '', type: String },
    pg: { default: '', type: String, required: true },
    duration: { default: 0, type: Number, required: true },
    dolby: { default: false, type: Boolean },
    sphera: { default: false, type: Boolean },
    threeDimensions: { default: false, type: Boolean },
    imax: { default: false, type: Boolean },
    imax3D: { default: false, type: Boolean },
    due: { default: '', type: String },
    url: { default: '#', type: String },
    genres: {
      default() {
        return []
      },
      type: Array,
    },
    dictionary: {
      default() {
        return { message: 'Object data' }
      },
      type: Object,
      required: true,
    },
  },
  emits: ['notify', 'notifyDevice'],
  methods: {
    showDueDate(date) {
      return getFormattedDateWithSeparators(
        date,
        getLocale(),
        { year: 'numeric', month: '2-digit', day: '2-digit' },
        '.'
      )
    },
    clickToNotify() {
      this.$emit('notify', this.recordId)
    },
    clickToNotifyDevice() {
      this.$emit('notifyDevice', this.recordId)
    },
  },
}
</script>
